module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/vendors.json
// module id = 632
// module chunks = 247357314507669